export const getFolderSubscriptions = async (
  apiBaseUrl,
  callProtectedApi,
  page = 1,
  size = 100,
  options = {},
) => {
  const url =
    `${apiBaseUrl}/api/v1/subscriptions/folders?` +
    `page=${encodeURIComponent(page)}&size=${encodeURIComponent(size)}`;

  return callProtectedApi(url, {
    ...options,
    headers: { "Content-Type": "application/json" },
  });
};

export const subscribeFolder = async (
  apiBaseUrl,
  callProtectedApi,
  folderId,
) => {
  const url = `${apiBaseUrl}/api/v1/subscriptions/folder/${encodeURIComponent(folderId)}`;
  return callProtectedApi(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
};

export const unsubscribeFolder = async (
  apiBaseUrl,
  callProtectedApi,
  folderId,
) => {
  const url = `${apiBaseUrl}/api/v1/subscriptions/folder/${encodeURIComponent(folderId)}`;
  return callProtectedApi(url, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
  });
};

export const getFavouriteStandards = async (
  apiBaseUrl,
  callProtectedApi,
  page = 1,
  size = 10,
) => {
  const url =
    `${apiBaseUrl}/api/v1/favorites/standards?` +
    `page=${encodeURIComponent(page)}&size=${encodeURIComponent(size)}`;

  return callProtectedApi(url, {
    headers: { "Content-Type": "application/json" },
  });
};

export const favoriteStandard = async (
  apiBaseUrl,
  callProtectedApi,
  standardId,
) => {
  const url = `${apiBaseUrl}/api/v1/favorites/standard/${encodeURIComponent(standardId)}`;
  return callProtectedApi(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
};

export const removeFavoriteStandard = async (
  apiBaseUrl,
  callProtectedApi,
  standardId,
) => {
  const url = `${apiBaseUrl}/api/v1/favorites/standard/${encodeURIComponent(standardId)}`;
  return callProtectedApi(url, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
  });
};
